import React from 'react';
import PropTypes from 'prop-types';
import {COMPONENT_TYPE} from '@learningblocks/exp-constants/lib/Utilities';
import './style.scss';

import FeedbackIcon from './img/Feedback-icon.svg'
import parse from 'html-react-parser'

const CLASSNAMES = {
  CORRECT: 'correct',
  INCORRECT: 'incorrect',
};

export class ResponseArea extends React.Component {
  renderFeedback() {
    if (this.props.savedResponse !== null) {
      return (
        <div style={{
          display: "flex",
          flexDirection: "row",
          padding: "8px",
          background: "#F5F7F9",
          border: "1px solid #336589",
          borderRadius: "5px",
          justifyContent: "center",
          margin: "8px 0"
        }}>
          <div>
            <img alt="Feedback icon." src={(this.props.feedbackIcon)?this.props.feedbackIcon:FeedbackIcon} style={{margin: 0}}/>
          </div>
          <p
            style={{flex: 1, margin: "0 0 0 8px", whiteSpace: "pre-wrap"}}
            className={"OpenEndedFeedback"}
            >
            {parse(this.props.feedback)}
          </p>
        </div>
      );
    } else {
     return null;
    }
  }

  updateResponseArea = (event) => {
    event.stopPropagation();

    if(event.target.value !== null){

      let payload = {
        componentID: this.props.componentID,
        responseArea: event.target.value,
      };

      this.props.responseOEQChange(payload)
    }
  }

  wrapperClass() {
    const classList = [this.props.className, 'responseArea'];
    if (this.props.disabled) {
      if (this.props.isCorrect) classList.push(CLASSNAMES.CORRECT);
      else classList.push(CLASSNAMES.INCORRECT);
    }
    return classList.join(' ');
  }

  render() {
    return (
      <>
        <div
          className={this.wrapperClass()}
          >
          <textarea
            rows="4"
            className="textarea-input"
            onInput={(e)=>this.updateResponseArea(e)}
            //id={this.props.text}
            value={this.props.id}
            disabled={this.props.disabled}
            placeholder="Answer here."
          >{this.props.savedResponse}</textarea>
        </div>
        {(this.props.feedback) &&this.renderFeedback()}
      </>
    );
  }
}
ResponseArea.propTypes = {
  className: PropTypes.string,
  componentID: PropTypes.number,
  feedback: PropTypes.string,
  id: PropTypes.number,
  isCorrect: PropTypes.bool,
  disabled: PropTypes.bool,
  responseOEQChange: PropTypes.func,
};
